(function() {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantQuickAdd);
  } else {
    initVariantQuickAdd();
  }

  function initVariantQuickAdd() {
    // 商品卡和购物车均可加载此资源，事件委托只注册一次。
    if (window.variantQuickAddInitialized) return;
    window.variantQuickAddInitialized = true;

		document.addEventListener('card:color-change', function(e) {
			updateQuickAddForColor(e.target, e.detail);
		});

    document.addEventListener('click', function(e) {
      const trigger = e.target.closest('.card-variant-bar__trigger');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        const bar = trigger.closest('.card-variant-bar');
        if (bar) bar.classList.add('is-open');
        return;
      }

      const variantBtn = e.target.closest('.card-variant-bar__variant, .card-variant-bar__add-btn');
      if (variantBtn) {
        handleVariantSelect(e);
        return;
      }

      const openBar = e.target.closest('.card-variant-bar.is-open');
      if (!openBar) {
        document.querySelectorAll('.card-variant-bar.is-open').forEach(function(bar) {
          bar.classList.remove('is-open');
        });
      }
    });
  }

	function updateQuickAddForColor(wrapper, detail) {
		const bar = wrapper.querySelector('.card-variant-bar');
		if (!bar || !detail || !detail.product || !detail.colorValue || !detail.optionPosition) return;

		const selectedOptions = getSelectedOptions(bar, detail.product);
		const colorIndex = detail.optionPosition - 1;
		const sizeIndex = Number(bar.dataset.sizeOptionPosition) - 1;

		if (colorIndex < 0 || colorIndex >= detail.product.options.length) return;
		selectedOptions[colorIndex] = detail.colorValue;
		bar.dataset.selectedOptions = JSON.stringify(selectedOptions);

		const quickOptionIndex = sizeIndex >= 0 ? sizeIndex : (colorIndex === 0 ? 1 : 0);
		const matchingVariants = detail.product.variants.filter(function(variant) {
			return variant.options.every(function(value, index) {
				return index === quickOptionIndex || value === selectedOptions[index];
			});
		});

		if (!matchingVariants.length) return;

		bar.classList.toggle('card-variant-bar--single', matchingVariants.length === 1);
		bar.classList.toggle('card-variant-bar--mobile-more', matchingVariants.length > 8);
		bar.classList.toggle('card-variant-bar--mobile-compact-more', matchingVariants.length > 5);

		const inner = bar.querySelector('.card-variant-bar__inner');
		if (!inner) return;

		inner.replaceChildren();
		bar.querySelector('.card-variant-bar__add-btn')?.remove();

		if (matchingVariants.length === 1) {
			const variant = matchingVariants[0];
			inner.appendChild(createVariantButton(variant, detail.product.title, quickOptionIndex, true));
			bar.appendChild(createAddButton(variant, detail.product.title));
			return;
		}

		const desktopDisplayLimit = matchingVariants.length > 10 ? 9 : 10;
		matchingVariants.slice(0, desktopDisplayLimit).forEach(function(variant) {
			inner.appendChild(createVariantButton(variant, detail.product.title, quickOptionIndex));
		});

		if (matchingVariants.length > 10) {
			inner.appendChild(createMoreLink(detail.variantUrl, 'card-variant-bar__more--desktop', matchingVariants.length));
		}
		if (matchingVariants.length > 5) {
			inner.appendChild(createMoreLink(detail.variantUrl, 'card-variant-bar__more--mobile', matchingVariants.length));
		}
	}

	function getSelectedOptions(bar, product) {
		try {
			const selectedOptions = JSON.parse(bar.dataset.selectedOptions || '[]');
			if (selectedOptions.length === product.options.length) return selectedOptions;
		} catch (error) {
			// Use the first variant when a legacy card does not include the selection data.
		}
		return product.variants[0].options.slice();
	}

	function createVariantButton(variant, productTitle, optionIndex, isSingleVariant) {
		const button = document.createElement('button');
		button.className = 'card-variant-bar__variant' + (isSingleVariant ? ' card-variant-bar__variant--single-mobile' : '');
		button.dataset.variantId = variant.id;
		button.dataset.variantTitle = variant.title;
		button.setAttribute('aria-label', 'Add ' + productTitle + ' - ' + variant.title + ' to bag' + (variant.available ? '' : ' - Sold out'));
		button.textContent = isSingleVariant ? (variant.available ? 'ADD TO BAG' : 'Sold out') : variant.options[optionIndex];
		if (!variant.available) {
			button.disabled = true;
			button.classList.add('soldout');
		}
		return button;
	}

	function createAddButton(variant, productTitle) {
		const button = createVariantButton(variant, productTitle, 0, true);
		button.classList.remove('card-variant-bar__variant', 'card-variant-bar__variant--single-mobile');
		button.classList.add('card-variant-bar__add-btn');
		return button;
	}

	function createMoreLink(url, modifierClass, count) {
		const link = document.createElement('a');
		link.href = url || '#';
		link.className = 'card-variant-bar__more ' + modifierClass;
		link.setAttribute('aria-label', 'View all ' + count + ' sizes');
		link.textContent = 'MORE';
		return link;
	}

  function handleVariantSelect(e) {
    e.preventDefault();
    e.stopPropagation();

    const btn = e.target.closest('.card-variant-bar__variant, .card-variant-bar__add-btn');
    if (!btn || btn.disabled || btn.classList.contains('loading')) return;

    const variantId = btn.dataset.variantId;
    const variantTitle = btn.dataset.variantTitle;

    if (variantId) {
      addToCart(variantId, 1, btn, variantTitle);
    }
  }

  function addToCart(variantId, quantity, btn, variantTitle) {
    // Culture Kings keeps the selected size visible on mobile until the cart drawer takes over.
    const isMobileVariantQuickAdd = window.matchMedia('(max-width: 749px)').matches &&
      btn.classList.contains('card-variant-bar__variant');

    btn.classList.add('loading');
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');

    const cartDrawer = document.querySelector('cart-drawer');
    const payload = { id: variantId, quantity: quantity };
    if (cartDrawer) {
      payload.sections = ['cart-drawer'];
      payload.sections_url = window.location.pathname + window.location.search;
    }

    // Liquid 路由没有 .js 后缀；JSON 请求必须使用 Ajax 接口。
    const addUrl = (window.routes?.cart_add_url || '/cart/add').replace(/\.js$/, '') + '.js';
    return fetch(addUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(data) {
      const addedItem = data.id ? data : data.items?.find(function(item) {
        return String(item.id) === String(variantId);
      });
      if (!data.status && addedItem) {
        // 加购时一并获取抽屉，避免等待另外两次串行请求。
        const drawerRendered = cartDrawer && data.sections?.['cart-drawer']
          ? renderQuickAddDrawer(cartDrawer, data.sections['cart-drawer'])
          : false;
        // On mobile, the cart drawer is the completion feedback. Avoid stacking a toast over it.
        if (!isMobileVariantQuickAdd || !cartDrawer) {
          const message = variantTitle
            ? 'Added: ' + variantTitle
            : 'Added to cart!';
          showToast(message, 'success');
        }

        if (!isMobileVariantQuickAdd) {
          const bar = btn.closest('.card-variant-bar');
          if (bar) bar.classList.remove('is-open');
        }

        const cartRefresh = fetch(window.routes?.cart_url ? window.routes.cart_url + '.js' : '/cart.js')
          .then(function(res) { return res.json(); })
          .then(function(cart) {
            document.querySelectorAll('#cart-icon-bubble, .cart-count, [data-cart-count]').forEach(function(el) {
              el.textContent = '(' + cart.item_count + ')';
              if (cart.item_count > 0) {
                el.classList.remove('hidden');
              }
            });

            document.dispatchEvent(new CustomEvent('cart:change', {
              detail: { cart: cart }
            }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));

            if (cartDrawer && !drawerRendered) {
              if (cart.item_count > 0) {
                cartDrawer.classList.remove('is-empty');
              }

              const drawerUrl = new URL('/cart', window.location.origin);
              drawerUrl.searchParams.set('section_id', 'cart-drawer');

              const previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
              if (previewThemeId) drawerUrl.searchParams.set('preview_theme_id', previewThemeId);

              return fetch(drawerUrl.toString())
                .then(function(r) { return r.text(); })
                .then(function(html) {
                  renderQuickAddDrawer(cartDrawer, html);
                });
            }
          });

        if (drawerRendered) {
          // 数量和兼容事件在后台更新，不阻塞抽屉反馈和按钮恢复。
          cartRefresh.catch(function(error) {
            console.error('Error refreshing cart:', error);
          });
          return;
        }
        return cartRefresh;

      } else {
        showToast(data.description || 'Failed to add to cart', 'error');
      }
    })
    .catch(function(error) {
      console.error('Error adding to cart:', error);
      showToast('Failed to add to cart', 'error');
    })
    .finally(function() {
      btn.classList.remove('loading');
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    });
  }

  function renderQuickAddDrawer(cartDrawer, html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newContent = doc.querySelector('#CartDrawer');
    const currentContent = document.querySelector('#CartDrawer');
    if (!newContent || !currentContent) return false;

    currentContent.innerHTML = newContent.innerHTML;
    cartDrawer.classList.remove('is-empty');
    const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', function() {
        cartDrawer.close();
      });
    }
    cartDrawer.open();
    return true;
  }

  function showToast(message, type) {
    const existingToast = document.querySelector('.variant-quick-add-toast');
    if (existingToast) {
      existingToast.remove();
    }

    const toast = document.createElement('div');
    toast.className = 'variant-quick-add-toast ' + type;
    toast.innerHTML = '<span class="toast-icon">' +
      (type === 'success' ? '&#10003;' : '&#10007;') +
      '</span><span>' + message + '</span>';
    document.body.appendChild(toast);

    requestAnimationFrame(function() {
      toast.classList.add('show');
    });

    setTimeout(function() {
      toast.classList.remove('show');
      setTimeout(function() {
        toast.remove();
      }, 300);
    }, 3000);
  }

  window.variantQuickAdd = {
    addToCart: addToCart,
    showToast: showToast
  };
})();
